import { BulkDeleteBotsModalProps } from "@shared/features/bots/types";
import Modal from "common/Modal/Modal";
import React from "react";
import Text from "common/Typography/Text";

const BulkDeleteBotsModal = ({
  isOpen,
  closeModal,
  onOk,
  content,
  isLoading,
}: BulkDeleteBotsModalProps) => {
  return (
    <Modal
      onCancel={closeModal}
      open={isOpen}
      title="Confirm Bulk Delete"
      onOk={onOk}
      okButtonProps={{
        loading: isLoading,
      }}
      cancelButtonProps={{ disabled: isLoading }}
      destroyOnHidden={true}
    >
      <Text>{content}</Text>
    </Modal>
  );
};

export default BulkDeleteBotsModal;
